<template>
  <div :class="`feedback-container ${className ? className : ''}`">
    <div :class="expanded ? 'feedback-asking expanded' : 'feedback-asking'">
      <span>{{ livechat_feedback_asking_feedback_message }}</span>

      <button class="feedback-start-button" @click="openFeedbackForm">
        {{ livechat_feedback_button_start }}
      </button>

      <button class="btn-show-feedback-asking" @click="expanded = !expanded">
        <i class="fa fa-angle-left" v-if="!expanded"></i>
        <i class="fa fa-angle-right" v-if="expanded"></i>
      </button>
    </div>

    <v-dialog id="dl_display_feedback" v-model="display_feedback" max-width="600">
      <v-card>
        <v-card-text class="dialog-feedback-container pa-5" v-if="feedback_done">
          <p class="mt-3 icon-heart">
            <i class="fa fa-heart" style="color: #F85959; font-size: 36px;"></i>
          </p>
          <p class="feedback-title">
            {{ livechat_feedback_thank_you_message }}
          </p>
          <button class="livechat-feedback-thanks-close" @click="display_feedback = !display_feedback">{{ livechat_feedback_button_close }}</button>
        </v-card-text>
        <v-card-text class="dialog-feedback-container pa-5" v-else>
          <p class="feedback-title">
            {{ livechat_feedback_asking_feedback_title }}
          </p>

          <div class="fb-text" v-if="type === const_feedback_type.TEXT">
            <button :class="genClassButtonFBText(message.level)" v-for="(message, idx) in messages" :key="idx" @click="select_fb_point(message.level)">{{ message.content }}</button>
          </div>
          <div class="fb-emotion" v-if="type === const_feedback_type.EMOTION_3">
            <button :class="select_feedback_point === 5 ? 'selected' : ''" @click="select_fb_point(5)">😄</button>
            <button :class="select_feedback_point === 3 ? 'selected' : ''" @click="select_fb_point(3)">😐</button>
            <button :class="select_feedback_point === 1 ? 'selected' : ''" @click="select_fb_point(1)">😠</button>
          </div>
          <div class="fb-emotion" v-if="type === const_feedback_type.EMOTION_5">
            <button :class="select_feedback_point === 5 ? 'selected' : ''" @click="select_fb_point(5)">😄</button>
            <button :class="select_feedback_point === 4 ? 'selected' : ''" @click="select_fb_point(4)">🙂</button>
            <button :class="select_feedback_point === 3 ? 'selected' : ''" @click="select_fb_point(3)">😐</button>
            <button :class="select_feedback_point === 2 ? 'selected' : ''" @click="select_fb_point(2)">☹️</button>
            <button :class="select_feedback_point === 1 ? 'selected' : ''" @click="select_fb_point(1)">😠</button>
          </div>
          <div :class="select_feedback_point !== 0 ? 'fb-star selected' : 'fb-star'" v-if="type === const_feedback_type.STAR">
            <button class="btn-star-1" :class="select_feedback_point === 1 ? 'selected' : ''" @click="select_fb_point(1)">⭐</button>
            <button class="btn-star-2" :class="select_feedback_point === 2 ? 'selected' : ''" @click="select_fb_point(2)">⭐</button>
            <button class="btn-star-3" :class="select_feedback_point === 3 ? 'selected' : ''" @click="select_fb_point(3)">⭐</button>
            <button class="btn-star-4" :class="select_feedback_point === 4 ? 'selected' : ''" @click="select_fb_point(4)">⭐</button>
            <button class="btn-star-5" :class="select_feedback_point === 5 ? 'selected' : ''" @click="select_fb_point(5)">⭐</button>
          </div>

          <v-textarea
            v-model="feedback_comment"
            :placeholder="livechat_feedback_ask_comment"
            maxlength="255"
            rows="2"
            outlined
            dense
            hide-details
            no-resize
            ></v-textarea>

          <button class="feedback-submit" :disabled="select_feedback_point===0" @click="submitFeedback">{{ livechat_feedback_button_submit }}</button>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import handlerData from '../business/handler_data.js';

export default {
  name: 'feedback',
  props: {
    config: null,
    className: null
  },
  data() {
    return {
      livechat_feedback_ask_comment: "Please leave your comment",
      livechat_feedback_button_start: "Feedback",
      livechat_feedback_asking_feedback_message: "How is your experience?",
      livechat_feedback_asking_feedback_title: "Rate your experience",
      livechat_feedback_button_submit: "Send",
      livechat_feedback_thank_you_message: "Thank you for your feedback!",
      livechat_feedback_button_close: "Close",
      messages: [],
      type: "emotion_3",

      const_feedback_type: {
        TEXT: 'text',
        EMOTION_3: 'emotion_3',
        EMOTION_5: 'emotion_5',
        STAR: 'star'
      },

      feedback_done: false,

      expanded: false,
      display_feedback: false,

      select_feedback_point: 0,
      feedback_comment: '',
    }
  },
  async mounted() {
    this.livechat_feedback_ask_comment = this.config.livechat_feedback_ask_comment
    this.livechat_feedback_button_start = this.config.livechat_feedback_button_start
    this.livechat_feedback_asking_feedback_message = this.config.livechat_feedback_asking_feedback_message
    this.livechat_feedback_asking_feedback_title = this.config.livechat_feedback_asking_feedback_title
    this.livechat_feedback_button_submit = this.config.livechat_feedback_button_submit
    this.livechat_feedback_thank_you_message = this.config.livechat_feedback_thank_you_message
    this.livechat_feedback_button_close = this.config.livechat_feedback_button_close
    this.type = this.config.type
    this.messages = this.config.messages
  },
  methods: {
    openFeedbackForm() {
      this.expanded = false;
      this.display_feedback = true;
    },
    select_fb_point(point) {
      this.select_feedback_point = point;
    },
    genClassButtonFBText(level) {
      if (level === 1) {
        return this.select_feedback_point === 1 ? 'fb-bad selected' : 'fb-bad'
      } else {
        return this.select_feedback_point === 5 ? 'fb-good selected' : 'fb-good'
      }
    },
    async submitFeedback() {
      if (this.select_feedback_point === 0) {
        return;
      }

      let score = this.select_feedback_point;
      let comment = this.feedback_comment;

      await handlerData.send_feedback(this.$store.state.botCode, this.$store.state.clientId, this.$store.state.clientToken, score, comment);

      this.feedback_done = true;
    }
  }
}
</script>

<style scoped>

@keyframes moving {
  0% {
    right: -230px;
  }

  20% {
    right: -170px;
  }

  40% {
    right: -120px;
  }

  60% {
    right: -80px;
  }

  80% {
    right: -40px;
  }

  100% {
    right: 7px;
  }
}
  .feedback-asking {
    position: absolute;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    /* padding: 10px; */
    /* border: 1px solid #ccc; */
    /* border-radius: 4px; */
    /* max-width: calc(100% - 23px);
    right: calc(-100% + 38px); */
    bottom: 56px;
    z-index: 10;
    background-color: #fff;

    font-size: 12px;
    font-family: Roboto, Noto Sans, Noto, sans-serif;
    padding: 10px 10px 10px 15px;
    border: 1px solid #ccc;
    border-radius: 9px;
    /* width: fit-content; */
    width: 300px;
    right: -285px;
  }

  .feedback-asking span {
    line-height: 20px;
  }

  .feedback-asking button.feedback-start-button, .livechat-feedback-thanks-close {
    width: fit-content;
    height: fit-content;
    border: none;
    padding: 2px 12px;
    border-radius: 4px;
    background: linear-gradient(90deg, #3353A2 0%, #31B7B7 100%);
    color: #fff;
    /* position: relative;
    top: calc(50% - 11px); */
    white-space: nowrap;
    align-self: center;
  }

  .feedback-asking.expanded {
    right: 7px;

    animation: linear 0.2s moving;
  }

  .btn-show-feedback-asking {
    position: absolute;
    top: calc(50% - 10px);
    left: -10px;
    font-size: 18px;
    display: block;
    border: 1px solid #ccc;
    background-color: white;
    width: 20px;
    height: 20px;
    line-height: 10px;
    padding: 0px 5px;
    border-radius: 10px;
  }

  .btn-show-feedback-asking:hover {
    cursor: pointer;
    background: linear-gradient(90deg, #3353A2 0%, #31B7B7 100%);
    color: white; 
  }

  .feedback-title {
    padding-top: 10px;
    margin-bottom: 20px;
    text-align: center;
    font-family: Roboto, Noto Sans, Noto, sans-serif;
    color: #131F31;
    font-size: 14px;
  }

  .dialog-feedback-container {
    text-align: center;
  }

  .dialog-feedback-container textarea, .v-textarea.v-text-field--enclosed .v-text-field__slot textarea {
    font-size: 14px !important;
  }

  .fb-emotion {
    display: flex;
    justify-content: space-around;
    font-size: 34px;
    margin: 15px;
    line-height: 34px;
    color: rgba(0, 0, 0, 1);
  }

  .fb-emotion button {
    border: none;
    background-color: transparent;
    padding: 0;
    margin: 0;
    filter: grayscale(100%);
    -webkit-filter: grayscale(100%);
  }

  .fb-emotion button:hover, .fb-emotion button.selected {
    filter: grayscale(0%);
    -webkit-filter: grayscale(0%);
  }

  .feedback-submit {
    text-align: center;
    padding: 5px 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background: linear-gradient(90deg, #3353A2 0%, #31B7B7 100%);
    font-size: 14px;
    cursor: pointer;
    color: white;
    line-height: 22px;
    margin: 10px auto 0;
  }

  .feedback-submit:disabled,
  .feedback-submit[disabled] {
    filter: grayscale(1);
    cursor: unset;
  }

  .fb-star {
    display: flex;
    justify-content: center;
    font-size: 30px;
    border: none;
    padding: 0;
    width: fit-content;
    margin: 0 auto 20px;
    color: rgba(0, 0, 0, 1);
  }

  .fb-star:hover button {
    filter: grayscale(0);
  }

  .fb-star button {
    border: none;
    background-color: transparent;
    padding: 0;
    margin: 0;
    filter: grayscale(1);
  }

  .fb-star.selected button {
    filter: grayscale(0);
  }
  .fb-star button:hover ~ button {
    filter: grayscale(1);
  }
  .fb-star button.selected ~ button {
    filter: grayscale(1);
  }

  .fb-text {
    margin-bottom: 20px;
  }
  .fb-text button {
    padding: 6px 12px;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 4px;
    cursor: pointer;
    margin: 0 5px;
    color: rgba(0, 0, 0, 1);
    font-weight: 700;
  }

  .fb-text button.fb-good:hover, .fb-text button.fb-good.selected {
    border-color: #326AED;
    background-color: #F5F8FF;
  }
  .fb-text button.fb-bad:hover, .fb-text button.fb-bad.selected {
    border-color: #D31313;
    background-color: #FFF5F5;
  }

  .icon-heart i {
    animation: beat .25s infinite alternate;
  }
  @keyframes beat {
    to {
      transform: scale(0.9);
    }
  }
</style>

<style>
  .dialog-feedback-container textarea {
    font-size: 14px !important;
    margin: 0 !important;
  }
</style>